<template>
  <section class="flowers">
    <div class="row no-gutters">
      <div class="col-6 col-md-3"
           v-if="galleryImages"
      v-for="(img, key) in galleryImages"
      :key="'gallery_' + key">
        <div class="flowers-img" @click="setCurrentImg(key)"><img :src="img.mini" :alt="key"></div>
      </div>

      <div class="col-12 col-md-3 flowers-button-show">
        <a class="flowers_text d-flex align-items-center justify-content-center" :href="'/' + vygonkaUrl">Смотреть нашу<br>выгонку</a>
      </div>
    </div>
  
    <transition v-if="isShowModal" name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
          
            <div class="prev-img arr">
              <button class="btn" @click="prev"></button>
            </div>
            <div class="modal-body">
              <img :src="currentImg.origin" alt="current">
            </div>
            <div class="next-img arr">
              <button class="btn" @click="next"></button>
            </div>
            <button class="btn my-close-btn"
                    @click="isShowModal = false">
            </button>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
  export default {
      name: 'gallery',
      data() {
          return {
              galleryImages,
              vygonkaUrl,
              currentImg: '',
              key: 0,
              isShowModal: false,
              length: 0,
          }
      },
      methods: {
          setCurrentImg(key) {
              this.key = key;
              this.currentImg = this.galleryImages[key];
              this.isShowModal = true;
          },
          prev() {
              if(this.key > 0) {
                  this.key = this.key - 1;
              } else {
                  this.key = this.length - 1;
              }
              this.currentImg = this.galleryImages[this.key];
          },
          next() {
              if(this.key < this.length - 1) {
                  this.key = this.key + 1;
              } else {
                  this.key = 0;
              }
              this.currentImg = this.galleryImages[this.key];
          }
      },
      mounted() {
          if(this.galleryImages && this.galleryImages.length > 0) {
              this.length = this.galleryImages.length;
          }
      },
  }
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// resources/js/components/elements/Gallery.vue